import React, { ReactElement, ReactNode } from 'react'
import classNames from 'classnames'
import { Container, Paragraph, Logo } from '@scentregroup/ui'
import { FooterSection } from './footer-section'
import style from './index.module.scss'

export interface ILink {
  label: string
  href: string
}

interface ISiteFooterProps {
  className?: string | null
  showAngle?: boolean
  colour?: 'brand' | 'seasonal'
  children: ReactNode
  links: ILink[]
}

export const SiteFooter = ({
  className = null,
  colour = 'seasonal',
  children,
  links = [],
  showAngle = true,
}: ISiteFooterProps): ReactElement => (
  <footer
    className={classNames(style.SiteFooter, className, {
      [style.showAngle]: showAngle,
      [style.seasonal]: showAngle && colour === 'seasonal',
      [style.brand]: showAngle && colour === 'brand',
    })}
    role="contentinfo"
  >
    <Container className={style.container} type="large">
      <Logo type="alt" className={style.logo} />
      {children && <FooterSection>{children}</FooterSection>}
      <FooterSection className={style.linksSection}>
        <Paragraph className={style.responsibleBusinessSection}>
          Scentre Group operates its Westfield Living Centre portfolio with a
          responsible business mindset across the four pillars of community,
          people, environment and economic performance. More information can be
          found in our{' '}
          <a
            className={style.rightsTextLink}
            href="https://www.scentregroup.com/getmedia/6bf752b0-bc41-4d63-8d50-3790d9c1a5f7/2020-Responsible-Business-Report.pdf?ext=.pdf"
          >
            2020 Responsible Business Report
          </a>
          .
        </Paragraph>
        <div className={style.linksWrapper}>
          {links && (
            <ul className={style.linksList}>
              {links.map(({ label, href }) => (
                <li key={href}>
                  <a href={href} className={style.link}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          )}
          <span className={style.rightsText}>
            <span>© All rights reserved.</span>
            <a
              href="https://www.scentregroup.com"
              className={style.rightsTextLink}
            >
              Scentre Group
            </a>
            <span>{new Date().getFullYear()}</span>
          </span>
        </div>
      </FooterSection>
    </Container>
  </footer>
)
